import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortRequestFormComponent } from './port-request-form.component';

const routes: Routes = [
  {
    path: '',
    component: PortRequestFormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortRequestFormRoutingModule {}
